module.exports = __webpack_public_path__ + "static/bg03-96965f1345ad626c180c0cb3d66324c0.jpg";